module.exports = __webpack_public_path__ + "assets/img/success.92ff120a.png";